import { CSSProperties } from 'react';

enum Background {
  light = 'light',
  dark = 'dark'
}

enum PxDensity {
  x1 = '1x',
  x2 = '2x',
  x3 = '3x'
}

interface Props {
  name: string;
  background?: Background;
  density?: PxDensity;
  style?: CSSProperties;
}

export function ExchangeIcon({ name, ...rest }: Props) {
  return (
    <img
      alt={name}
      src={`/assets/exchanges/png/100x100/${
        name.toLowerCase().split(' ')[0]
      }.png`}
      onError={e => {
        e.currentTarget.src = '/assets/cryptoIcons/generic.svg';
      }}
      style={{ height: '2rem' }}
      {...rest}
    />
  );
}
